(function () {
  window.Eurus = window.Eurus || {};
  var loaded = window.Eurus.loadedScript;
  var alreadyLoaded = false;

  if (loaded && typeof loaded.has === 'function') {
    alreadyLoaded = loaded.has('flexible-area.js');
  } else if (Array.isArray(loaded)) {
    alreadyLoaded = loaded.indexOf('flexible-area.js') !== -1;
  }

  if (alreadyLoaded) return;

  if (loaded && typeof loaded.add === 'function') {
    loaded.add('flexible-area.js');
  } else {
    window.Eurus.loadedScript = Array.isArray(loaded) ? loaded : [];
    window.Eurus.loadedScript.push('flexible-area.js');
  }

  var registerFlexibleArea = function () {
    if (!window.Alpine || window.Eurus.flexibleAreaRegistered) return;
    window.Eurus.flexibleAreaRegistered = true;

    Alpine.data('xFlexibleArea', function () {
      return {
        resizeObserver: null,

        initArea: function (el) {
          var self = this;
          this.adjustFlexWidths(el);
          if (typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(function () {
              self.adjustFlexWidths(el);
            });
            this.resizeObserver.observe(el);
          } else {
            window.addEventListener('resize', function () {
              self.adjustFlexWidths(el);
            });
          }
        },

        adjustFlexWidths: function (container) {
          if (!container) return;
          var viewportWidth = window.xViewport && window.xViewport.innerWidth
            ? window.xViewport.innerWidth
            : window.innerWidth;
          var isMobile = viewportWidth <= 767;
          var children = Array.prototype.slice.call(container.children);
          var items = children.map(function (el) {
            var itemBlock = el.querySelector('.item-block');
            if (!itemBlock) return null;
            var rawWidth = isMobile ? itemBlock.dataset.widthMobile : itemBlock.dataset.width;
            var itemWidth = parseFloat(rawWidth) || 100;
            return { el: el, itemWidth: itemWidth };
          }).filter(Boolean);

          var style = getComputedStyle(container);
          var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
          var containerWidth = container.getBoundingClientRect().width;
          if (!containerWidth) return;

          var currentRow = [];
          var currentTotal = 0;
          var self = this;

          items.forEach(function (item) {
            if (currentRow.length && currentTotal + item.itemWidth > 100.01) {
              self.applyRowWidths(currentRow, gap, containerWidth);
              currentRow = [item];
              currentTotal = item.itemWidth;
            } else {
              currentRow.push(item);
              currentTotal += item.itemWidth;
            }
          });

          self.applyRowWidths(currentRow, gap, containerWidth);
        },

        applyRowWidths: function (row, gap, containerWidth) {
          if (!row.length || !containerWidth) return;
          var totalGap = gap * (row.length - 1);
          var usableWidth = 100 - (totalGap / containerWidth) * 100;
          row.forEach(function (item) {
            item.el.style.flex = '0 0 ' + (usableWidth * (item.itemWidth / 100)) + '%';
            item.el.style.minWidth = '0';
          });
        }
      };
    });
  };

  if (window.Alpine) {
    registerFlexibleArea();
  } else {
    document.addEventListener('alpine:init', registerFlexibleArea, { once: true });
  }
})();
